export class City {
    cityId: number;
    countryId: number;
    displayName: string;
    name: string;
    cityName: string;
    countryName: string;
}
